import gql from 'graphql-tag'

export const QUERY_FLYERS = gql`
  query Flyers(
    $status: [FlyerStatus]
    $date: [String]
    $page: Int
    $pageSize: Int
    $sort: [String]
    $sortDirection: [SortDirection]
    $franchise: Boolean
    $search: String
    $units: [ID]
    $only_franchise: Boolean
  ) {
    flyers(
      status: $status
      date: $date
      page: $page
      pageSize: $pageSize
      sort: $sort
      sortDirection: $sortDirection
      franchise: $franchise
      search: $search
      units: $units
      only_franchise: $only_franchise
    ) {
      records
      page
      flyers {
        _id
        title
        description
        scheduled
        active
        status
        medium
        priority
        products {
          sku
          name
        }
        units {
          _id
          id_erp
          name
        }
        initial_date
        final_date
        images
        thumbnails
        metrics {
          chatbot {
            total_views
          }
          app {
            total_clicks
          }
        }
        created_at
        updated_at
      }
    }
  }
`

export const QUERY_FLYER = gql`
  query Flyer($_id: ID!, $franchise: Boolean, $only_franchise: Boolean) {
    flyer(_id: $_id, franchise: $franchise, only_franchise: $only_franchise) {
      _id
      title
      description
      scheduled
      active
      status
      medium
      priority
      products {
        sku
        name
      }
      units {
        _id
        id_erp
        name
      }
      initial_date
      final_date
      original_file {
        filename
        url
      }
      images
      thumbnails
      created_at
      updated_at
      metrics {
        chatbot {
          total_views
          push_views
          chat_views
          pushes_received
          pushes_opened
        }
        app {
          total_clicks
        }
      }
    }
  }
`

export const QUERY_FLYER_CAMPAIGNS = gql`
  query CampaignsFlyer($flyer_id: ID!) {
    campaigns(flyer: $flyer_id, mode: CHATBOT_PUSH) {
      campaigns {
        _id
        title
        description
        mode
        message {
          text
          send_date
          send_time
        }
        metrics {
          clients_metrics {
            received {
              count
            }
          }
        }
      }
    }
  }
`

export const MUTATION_UPSERT_FLYER = gql`
  mutation UpsertFlyer($data: FlyerInput!) {
    upsertFlyer(data: $data) {
      _id
    }
  }
`

export const MUTATION_UPSERT_DRAFT_FLYER = gql`
  mutation UpsertDraftFlyer($data: DraftFlyerInput!) {
    upsertDraftFlyer(data: $data) {
      _id
    }
  }
`
export const MUTATION_DELETE_FLYER = gql`
  mutation DeleteFlyer($_id: ID!) {
    deleteFlyer(_id: $_id) {
      ok
      message
    }
  }
`

export const MUTATION_CLONE_FLYER = gql`
  mutation CloneFlyer($_id: ID!) {
    cloneFlyer(_id: $_id) {
      _id
    }
  }
`

export const MUTATION_TOGGLE_FLYER = gql`
  mutation ToggleFlyer($_id: ID!, $active: Boolean!) {
    toggleFlyer(_id: $_id, active: $active) {
      ok
      message
    }
  }
`

export const MUTATION_UPLOAD_AND_CONVERT_PAGES_TO_IMAGES = gql`
  mutation UploadAndConvertPagesToImages($file: Upload!, $prefix: String!) {
    uploadAndConvertPagesToImages(file: $file, prefix: $prefix) {
      original {
        filename
        url
      }
      images {
        url
      }
      thumbnails {
        url
      }
    }
  }
`
export const UPLOAD_AND_CONVERT_PAGES_TO_IMAGES =
  'subscription UploadAndConvertPagesToImages($roomId: String!) {\n  uploadAndConvertPagesToImages(roomId: $roomId) {\n    images {\n      encoding\n      filename\n      mimetype\n      url\n    }\n    original {\n      encoding\n      filename\n      mimetype\n      url\n    }\n    thumbnails {\n      encoding\n      filename\n      mimetype\n      url\n    }\n    __typename\n  }\n}'

export const QUERY_ACTIVE_UPLOAD_AND_CONVERT_PAGES_TO_IMAGES_JOB = gql`
  query ActivateUploadAndConvertPagesToImagesJob($roomId: String!, $prefix: String!, $file: Upload!) {
    activateUploadAndConvertPagesToImagesJob(roomId: $roomId, prefix: $prefix, file: $file) {
      status
      message
    }
  }
`
